import React from 'react'
import { utils } from 'alelo-logic'

import { violet, orange, yellow } from 'styles/settings/colors'
import ConsumptionChartBar from '../../elements/ConsumptionChartBar'
import ConsumptionChartIndicator from '../../elements/ConsumptionChartIndicator'

import { Title, Text, IndicatorList, Usage, IndicatorItem } from './styles'

import { consumptionLabel, indicatorLabel } from './data.json'

const { currencyParser } = utils
const colors = [violet, orange, yellow]

const toPercentage = (value, total) => {
  const decimal = value / total
  return decimal * 100
}

// TODO: move to logic
const calculateDataPercentage = (dataArray = [], maxValue) => {
  if (maxValue) {
    return dataArray.map(data => toPercentage(data, maxValue))
  }

  const total = dataArray.reduce((data, nextData) => data + nextData, 0)

  return dataArray.map(data => toPercentage(data, total))
}

const ConsumptionChart = ({ consumption, balance }) => {
  const data = (consumption && consumption.spending) || (balance && balance.spending)
  const consumptionTypes = Object.keys(data)
  const consumptionValues = consumptionTypes.map(consumptionType => data[consumptionType])
  const dataPercentage =
    calculateDataPercentage(consumptionValues, consumption && consumption.limit) || []
  const totalPercentage = dataPercentage.reduce((percentage, nextData) => percentage + nextData, 0)

  return (
    <section>
      {balance && <Title>últimos 30 dias</Title>}

      <ConsumptionChartBar colors={colors} values={dataPercentage} />

      {consumption && (
        <Usage>
          <span>{totalPercentage}%</span>

          <span>De {currencyParser(consumption.limit, 'R$ ')}</span>
        </Usage>
      )}
      <IndicatorList>
        <IndicatorItem>
          <Text>{consumptionLabel}</Text>
        </IndicatorItem>
        {consumptionTypes.map((indicator, index) => (
          <IndicatorItem key={indicator}>
            <ConsumptionChartIndicator
              name={indicatorLabel[indicator]}
              color={colors[index]}
              value={currencyParser(data[indicator])}
            />
          </IndicatorItem>
        ))}
      </IndicatorList>
    </section>
  )
}

export default ConsumptionChart



// WEBPACK FOOTER //
// ./src/app/modules/ConsumptionChart/index.js